import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Switch, Route, useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import Subscribe from '../../components/Subscribe/Subscribe';
import ColorExtractor from '../../components/ColorExtractor/ColorExtractor';
import Templates from '../../components/Contents/Templates';
import Support from '../../components/Contact/Contact';
import {
  FeaturesPage,
  BlurPage,
  GridPage,
  StickerPage,
  TextPage,
  TransparencyPage,
  IconPage,
  EffectPage,
  StraightenPage,
  SpeechPage,
  CroppingPage,
  TexturePage,
  FramePage,
  VignettePage,
} from '../../components/Contents/featuresPages/FeaturesPages';
import Error from '../../components/Error/Error';
import EntryForm from '../../components/VEntry/EntryForm';
import {
  Button,
  Container,
  Icon,
  Image,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Dropdown,
} from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import StaticPages from '../../components/Contents/StaticPages';
import LoginMenu from './LoginMenu';
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector';
import PrivacyPolicyPage from '../../components/privacyPolicy';

// Heads up!
// We using React Static to prerender our docs with server side rendering, this is a quite simple solution.
// For more advanced usage please check Responsive docs under the "Usage" section.
const getWidth = () => {
  const isSSR = typeof window === 'undefined';

  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth;
};

const MainContent = props => {
  const languages = [
    { key: 1, text: 'فارسی', value: 'rtl/fa-IR' },
    { key: 2, text: 'English', value: 'ltr/en-US' },
    { key: 3, text: 'العربی', value: 'rtl/ar-SA' },
    { key: 4, text: 'Turkish', value: 'ltr/tr-Tr' },
  ];

  const localLanguage = localStorage.getItem('language');
  const defaultLanguage = localLanguage ? localLanguage : 'rtl/fa-IR';

  const onChangeLanguage = (e, { value }) => {
    localStorage.setItem('language', value);
    window.location.reload();
  };

  return (
    <Switch>
      <Route path={props.path} exact>
        {/* <div className="backgroundContainer">
          <Container className="firstPageContainer">
            <div className="loginBg"></div>
            {!props.mobile && (
              <div className="homeLeftSide">
                <img
                  alt="ابزار طراحی آنلاین گرافیک"
                  src={require('../../assets/images/homePic.png')}
                />
              </div>
            )}
            <div className={props.mobile ? 'homeCenter' : 'homeRightSide'}>
              <EntryForm form={props.formShow} />
              <div className="languageBox">
                <Dropdown
                  icon="world"
                  labeled
                  search
                  selection
                  options={languages}
                  defaultValue={defaultLanguage}
                  onChange={onChangeLanguage}
                />
              </div>
            </div>
          </Container>
        </div> */}
        <div className="firstPageContent">
          <StaticPages language={localLanguage} />
        </div>
      </Route>
      <Route exact path={`/features`} component={FeaturesPage} />
      <Route path={`/features/blur`} component={BlurPage} />
      <Route path={`/features/icon`} component={IconPage} />
      <Route path={`/features/effect`} component={EffectPage} />
      <Route path={`/features/straighten`} component={StraightenPage} />
      <Route path={`/features/speech`} component={SpeechPage} />
      <Route path={`/features/grid`} component={GridPage} />
      <Route path={`/features/sticker`} component={StickerPage} />
      <Route path={`/features/text`} component={TextPage} />
      <Route path={`/features/transparency`} component={TransparencyPage} />
      <Route path={`/features/cropping`} component={CroppingPage} />
      <Route path={`/features/texture`} component={TexturePage} />
      <Route path={`/features/frame`} component={FramePage} />
      <Route path={`/features/vignette`} component={VignettePage} />
      <Route path={`/subscribe`} component={Subscribe} />
      <Route path={`/colorExtractor`} component={ColorExtractor} />
      <Route path={`/templates`} component={Templates} />
      <Route path={`/support`} component={Support} />
      <Route path={`/privacy-policy`} component={PrivacyPolicyPage} />
      <Route path="*" render={() => <Error error={'404'} redirectTo={'support'} />} />
    </Switch>
  );
};

MainContent.propTypes = {
  mobile: PropTypes.any,
  formShow: PropTypes.any,
  path: PropTypes.string,
};

const DesktopContainer = props => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { path } = useRouteMatch();
  const [form, setForm] = useState('login');
  const [activeItem, setActiveItem] = useState(location.pathname);
  const handleItemClick = (e, { path }) => {
    setActiveItem(path);
    history.push(path);
    const pathMode = path.charAt(1);

    if (pathMode === '#') {
      const id = path.substr(2, path.length - 1);
      let yOffset = -60;
      const element = document.getElementById(id);
      if (element) {
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  };

  const handleClick = (e, { title }) => {
    setActiveItem('/');
    if (title !== 'login' && title !== 'register') history.push('/');
    setForm(title);
    const element = document.getElementById('home');
    if (element) {
      const y = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <Responsive className="mondaPublicDesktop" getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
        <Segment
          className="mondaPublicDesktopContent"
          // inverted
          // textAlign="center"
          style={{ minHeight: 700, padding: '1em 0em' }}
          vertical
        >
          <Menu fixed="top" pointing secondary size="large" className="mondaPublicHeader">
            <Container>
              <div className="vibinoLogo"></div>
              {/* <Image
                className="vibinoLogo"
                src={require('../../assets/images/vibinoLogoYellow.svg')}
              /> */}
              <div className="menuContainer">
                <Menu.Item
                  active={activeItem === '/#home'}
                  as="a"
                  path="/#home"
                  content={t('home')}
                  onClick={handleItemClick}
                />
                <Menu.Item
                  active={activeItem === '/#aboutVibino'}
                  as="a"
                  path="/#aboutVibino"
                  content={t('whatIsVibino')}
                  onClick={handleItemClick}
                />
                <Menu.Item
                  active={activeItem === '/#features'}
                  as="a"
                  path="/#features"
                  content={t('features')}
                  onClick={handleItemClick}
                />
                {/* Legacy feature submenus are intentionally hidden from the education landing header.
                  <span>{t('features')}</span>
                  <div className="dropdownBox">
                    <Menu.Item
                      active={activeItem === '/#features'}
                      className="dropdown"
                    >
                      <img src="/assets/images/icons/Image.svg" />
                      <span>{t('imageEditing')}</span>
                      <div className="subDropDownBox">
                        <Menu.Item
                          active={activeItem === '/features/cropping'}
                          as="a"
                          path="/features/cropping"
                          content={t('croppingMenuTitle')}
                          onClick={handleItemClick}
                        />
                        <Menu.Item
                          active={activeItem === '/features/blur'}
                          as="a"
                          path="/features/blur"
                          content={t('blurMenuTitle')}
                          onClick={handleItemClick}
                        />
                        <Menu.Item
                          active={activeItem === '/features/straighten'}
                          as="a"
                          path="/features/straighten"
                          content={t('straightenMenuTitle')}
                          onClick={handleItemClick}
                        />
                        <Menu.Item
                          active={activeItem === '/features/grid'}
                          as="a"
                          path="/features/grid"
                          content={t('gridMenuTitle')}
                          onClick={handleItemClick}
                        />
                      </div>
                    </Menu.Item>
                    <Menu.Item
                      active={activeItem === '/#features'}
                      className="dropdown"
                    >
                      <img src="/assets/images/icons/Graphic-text.svg" />
                      <span>{t('graphicAndText')}</span>
                      <div className="subDropDownBox">
                        <Menu.Item
                          active={activeItem === '/features/sticker'}
                          as="a"
                          path="/features/sticker"
                          content={t('stickerMenuTitle')}
                          onClick={handleItemClick}
                        />
                        <Menu.Item
                          active={activeItem === '/features/speech'}
                          as="a"
                          path="/features/speech"
                          content={t('speechMenuTitle')}
                          onClick={handleItemClick}
                        />
                        <Menu.Item
                          active={activeItem === '/features/icon'}
                          as="a"
                          path="/features/icon"
                          content={t('iconMenuTitle')}
                          onClick={handleItemClick}
                        />
                        <Menu.Item
                          active={activeItem === '/features/frame'}
                          as="a"
                          path="/features/frame"
                          content={t('frameMenuTitle')}
                          onClick={handleItemClick}
                        />
                        <Menu.Item
                          active={activeItem === '/features/text'}
                          as="a"
                          path="/features/text"
                          content={t('textMenuTitle')}
                          onClick={handleItemClick}
                        />

                      </div>
                    </Menu.Item>
                    <Menu.Item
                      active={activeItem === '/#features'}
                      className="dropdown"
                    >
                      <img src="/assets/images/icons/Effect.svg" />
                      <span>{t('effects')}</span>
                      <div className="subDropDownBox">
                        <Menu.Item
                          active={activeItem === '/features/effect'}
                          as="a"
                          path="/features/effect"
                          content={t('effectMenuTitle')}
                          onClick={handleItemClick}
                        />
                        <Menu.Item
                          active={activeItem === '/features/texture'}
                          as="a"
                          path="/features/texture"
                          content={t('textureMenuTitle')}
                          onClick={handleItemClick}
                        />
                        <Menu.Item
                          active={activeItem === '/features/transparency'}
                          as="a"
                          path="/features/transparency"
                          content={t('transparencyMenuTitle')}
                          onClick={handleItemClick}
                        />
                        <Menu.Item
                          active={activeItem === '/features/vignette'}
                          as="a"
                          path="/features/vignette"
                          content={t('vignetteMenuTitle')}
                          onClick={handleItemClick}
                        />
                      </div>
                    </Menu.Item>
                  </div>
                </Menu.Item> */}

                <Menu.Item
                  active={activeItem === '/#benefits'}
                  as="a"
                  path="/#benefits"
                  content={t('benefits')}
                  onClick={handleItemClick}
                />
                <Menu.Item
                  active={activeItem === '/templates'}
                  as="a"
                  path="/templates"
                  content={t('templates')}
                  onClick={handleItemClick}
                />
                {/* <Menu.Item
                  active={activeItem === '/#subscribe'}
                  as="a"
                  path="/#subscribe"
                  content={t('subscribe')}
                  onClick={handleItemClick}
                /> */}
                <Menu.Item active={activeItem === '/blog'} as="a" link={true} href="/blog" content={t('blog')} />
                {/* <Menu.Item
                  active={activeItem === '/support'}
                  as="a"
                  path="/support"
                  content={t('support')}
                  onClick={handleItemClick}
                /> */}
              </div>
              <Menu.Item position="left">
                <LoginMenu />
                <LanguageSelector lite />
              </Menu.Item>
            </Container>
          </Menu>

          <MainContent formShow={form} path={path} />
        </Segment>
      {props.children}
    </Responsive>
  );
};

DesktopContainer.propTypes = {
  children: PropTypes.any,
};

const MobileContainer = props => {
  const { t } = useTranslation();
  const [sidebarOpened, setSidebarOpened] = useState(false);
  const [form, setForm] = useState('login');

  const history = useHistory();
  const location = useLocation();
  const { path } = useRouteMatch();
  const [activeItem, setActiveItem] = useState(location.pathname);

  const handleItemClick = (e, { path }) => {
    setSidebarOpened(false);
    setActiveItem(path);
    history.push(path);
    const pathMode = path.charAt(1);

    if (pathMode === '#') {
      const id = path.substr(2, path.length - 1);
      let yOffset = 0;
      const element = document.getElementById(id);
      if (element) {
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  };
  const handleClick = (e, { title }) => {
    setSidebarOpened(false);
    setActiveItem('/');
    if (title !== 'login' && title !== 'register') history.push('/');
    setForm(title);
  };

  const { children } = props;

  return (
    <Responsive
      as={Sidebar.Pushable}
      getWidth={getWidth}
      maxWidth={Responsive.onlyMobile.maxWidth}
      className="mobileContainer"
    >
      <Sidebar
        as={Menu}
        direction="right"
        animation="push"
        inverted
        onHide={() => setSidebarOpened(false)}
        vertical
        visible={sidebarOpened}
      >
        <Menu.Item
          active={activeItem === '/#home'}
          as="a"
          path="/#home"
          content={t('home')}
          onClick={handleItemClick}
        />
        <Menu.Item
          active={activeItem === '/#aboutVibino'}
          as="a"
          path="/#aboutVibino"
          content={t('whatIsVibino')}
          onClick={handleItemClick}
        />
        <Menu.Item
          active={activeItem === '/#features'}
          as="a"
          path="/#features"
          content={t('features')}
          onClick={handleItemClick}
        />
        <Menu.Item
          active={activeItem === '/#benefits'}
          as="a"
          path="/#benefits"
          content={t('benefits')}
          onClick={handleItemClick}
        />
        <Menu.Item
          active={activeItem === '/templates'}
          as="a"
          path="/templates"
          content={t('templates')}
          onClick={handleItemClick}
        />
        {/* <Menu.Item
          active={activeItem === '/#subscribe'}
          as="a"
          path="/#subscribe"
          content={t('subscribe')}
          onClick={handleItemClick}
        /> */}
        {/* <Menu.Item
          active={activeItem === '/'}
          as="a"
          path="/"
          content={t('home')}
          onClick={handleItemClick}
        />
        <Menu.Item
          active={activeItem === '/features'}
          as="a"
          path="/features"
          content={t('features')}
          onClick={handleItemClick}
        />
        <Menu.Item
          active={activeItem === '/subscribe'}
          as="a"
          path="/subscribe"
          content={t('subscribe')}
          onClick={handleItemClick}
        />
        <Menu.Item
          active={activeItem === '/support'}
          as="a"
          path="/support"
          content={t('support')}
          onClick={handleItemClick}
        /> */}
        {/* <Menu.Item title="login" onClick={handleClick} content={t('login')} />
        <Menu.Item title="register" onClick={handleClick} content={t('register')} /> */}
        <LoginMenu mobile />
        <LanguageSelector mobile />
      </Sidebar>

      <Sidebar.Pusher dimmed={sidebarOpened}>
        <Segment
          className="mondaPublicMobileContent"
          textAlign="center"
          style={{ minHeight: 350, padding: '1em 0em' }}
          vertical
        >
          <Container className="mondaPublicMobileHeader">
            <Menu pointing secondary size="large">
              <Menu.Item position="right">
                <div className="vibinoLogo"></div>
                {/* <Image className="vibinoLogo" src={require('../../assets/images/vibinoLogoYellow.svg')} /> */}
              </Menu.Item>
              <Menu.Item position="left" onClick={() => setSidebarOpened(true)}>
                <Icon name="sidebar" />
              </Menu.Item>
            </Menu>
          </Container>
          <MainContent formShow={form} path={path} mobile />
        </Segment>
        {children}
      </Sidebar.Pusher>
    </Responsive>
  );
};

MobileContainer.propTypes = {
  children: PropTypes.any,
};

const ResponsiveContainer = ({ children }) => (
  <div id="home" className="masterHome">
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </div>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.any,
};

const HomepageLayout = () => {
  return <ResponsiveContainer></ResponsiveContainer>;
};

export default HomepageLayout;
